import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import * as L from 'leaflet';
import 'leaflet-draw';
@Component({
  selector: 'app-map-polygon',
  templateUrl: './map-with-polygon.component.html',
  styleUrls: ['./map-with-polygon.component.scss']
})
export class MapPolygonComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() height: string = '400px';
  @Input() width: string = '100%';

  @Input() coordinates?: any;
  @Input() geoType!: 'Point' | 'LineString' | 'Polygon' | 'MultiPolygon';

  @Input() ocorrencias?: any[];
  @Input() geoData: any[] = [];

  @Input() mapId = 'map';

  @Input() disableLegend: boolean = false

  @Input() extraPoints: any;

  @Input() enableDrawning: boolean = false

  @Output() polygonCoordinates = new EventEmitter<any>()

  private map?: L.Map;
  private layerGroup?: L.FeatureGroup;
  drawnItems = new L.FeatureGroup();

  constructor() {
    const defaultIcon = L.icon({
      iconUrl: '/assets/images/marker-icon-2x-green.png',
      shadowUrl: '/assets/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      tooltipAnchor: [16, -28],
      shadowSize: [41, 41]
    });
    L.Marker.prototype.options.icon = defaultIcon;
  }

  ngAfterViewInit(): void {
    const el = document.getElementById(this.mapId);
    if (!el) return;

    el.style.height = this.height || '400px';
    el.style.width = this.width || '100%';
    el.style.borderRadius = '10px';


    this.initMap([-22.9068, -43.1729]);
  }

  initMap(center?) {
    this.map = L.map(this.mapId, {
      center,
      zoom: 13
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap'
    }).addTo(this.map);

    if (!this.enableDrawning) this.addLegend(this.mapId);
    this.drawLayers();
    setTimeout(() => this.map?.invalidateSize(), 100);
    if (this.enableDrawning) {
      this.setDraw(this.map)
    }
  }

  setDraw(map: L.Map) {
    map.addLayer(this.drawnItems);
    (L as any).drawLocal = {
      draw: {
        toolbar: {
          actions: {
            title: 'Cancelar desenho',
            text: 'Cancelar'
          },
          finish: {
            title: 'Finalizar desenho',
            text: 'Finalizar'
          },
          undo: {
            title: 'Apagar último ponto',
            text: 'Desfazer'
          },
          buttons: {
            polyline: 'Desenhar linha',
            polygon: 'Desenhar polígono',
            rectangle: 'Desenhar retângulo',
            circle: 'Desenhar círculo',
            marker: 'Adicionar marcador',
            circlemarker: 'Adicionar marcador circular'
          }
        },
        handlers: {
          circle: {
            tooltip: {
              start: 'Clique e arraste para desenhar um círculo.'
            },
            radius: 'Raio'
          },
          circlemarker: {
            tooltip: {
              start: 'Clique no mapa para colocar o marcador.'
            }
          },
          marker: {
            tooltip: {
              start: 'Clique no mapa para colocar o marcador.'
            }
          },
          polygon: {
            tooltip: {
              start: 'Clique para começar o polígono.',
              cont: 'Clique para continuar desenhando.',
              end: 'Clique no primeiro ponto para finalizar.'
            }
          },
          polyline: {
            error: '<strong>Erro:</strong> as bordas não podem se cruzar!',
            tooltip: {
              start: 'Clique para começar a linha.',
              cont: 'Clique para continuar desenhando.',
              end: 'Clique no último ponto para finalizar.'
            }
          },
          rectangle: {
            tooltip: {
              start: 'Clique e arraste para desenhar o retângulo.'
            }
          },
          simpleshape: {
            tooltip: {
              end: 'Solte o mouse para finalizar o desenho.'
            }
          }
        }
      },
      edit: {
        toolbar: {
          actions: {
            save: {
              title: 'Salvar alterações',
              text: 'Salvar'
            },
            cancel: {
              title: 'Cancelar edição',
              text: 'Cancelar'
            },
            clearAll: {
              title: 'Remover tudo',
              text: 'Remover tudo'
            }
          },
          buttons: {
            edit: 'Editar camadas',
            editDisabled: 'Não há camadas para editar.',
            remove: 'Excluir camadas',
            removeDisabled: 'Não há camadas para excluir.'
          }
        },
        handlers: {
          edit: {
            tooltip: {
              text: 'Arraste os marcadores para editar a forma.',
              subtext: 'Clique em cancelar para desfazer alterações.'
            }
          },
          remove: {
            tooltip: {
              text: 'Clique em uma forma para removê-la.'
            }
          }
        }
      }
    };

    const drawControl = new L.Control.Draw({
      edit: {
        featureGroup: this.drawnItems
      },
      draw: {
        polyline: false,
        rectangle: false,
        circle: false,
        circlemarker: false,
        marker: {
          icon: L.icon({
            iconUrl: '/assets/images/map-marker-icon.png',
            iconSize: [48, 48],
            iconAnchor: [24, 48],
            popupAnchor: [0, -48],
            tooltipAnchor: [0, -36],
            shadowUrl: undefined
          })
        }
      },
    });

    map.addControl(drawControl);

    map.on(L.Draw.Event.CREATED, (e: any) => {
      this.drawnItems.clearLayers();


      const layer = e.layer;
      this.drawnItems.addLayer(layer);
      this.polygonCoordinates.emit({ type: "Point", coordinates: [] })
      this.polygonCoordinates.emit(layer.toGeoJSON().geometry)
    });

    this.map.on(L.Draw.Event.EDITED, (e: any) => {
      const layers = e.layers;
      layers.eachLayer((layer: any) => {
        if (layer instanceof L.Polygon || layer instanceof L.Marker) {
          const geometry = layer.toGeoJSON().geometry;
          this.polygonCoordinates.emit(geometry);
        }
      });
    });

  }

  ngOnChanges(changes: SimpleChanges): void {
    const el = document.getElementById(this.mapId);

    if (el && (changes['height'] || changes['width'])) {
      if (changes['height']) el.style.height = this.height || '400px';
      if (changes['width']) el.style.width = this.width || '100%';
      this.map?.invalidateSize();
    }

    if (this.map && (changes['coordinates'] || changes['geoType'] || changes['geoData'])) {
      this.drawLayers();
    }
  }

  ngOnDestroy(): void {
    this.map?.remove();
    this.map = undefined;
  }

  private addLegend(el): void {
    if (!this.map) return;

    const legend = new L.Control({ position: 'bottomright' });

    legend.onAdd = () => {
      const div = L.DomUtil.create('div', 'info-legend');
      div.innerHTML = this.disableLegend ?
        `<div style="margin-bottom: 5px; font-weight: bold;">Legenda</div>
          <div>
            <i style="background: green;"></i> Localidade Consultada
          </div>` :
        `<div style="margin-bottom: 5px; font-weight: bold;">Legenda</div>
          <div>
            <i style="background: green;"></i> Localidade Consultada
          </div>
          <div>
            <i style="background: red;"></i> Inconformidade
          </div>`;
      return div;
    };

    legend.addTo(this.map);
  }

  private drawLayers(): void {
    if (!this.map) return;

    if (this.layerGroup) {
      this.map.removeLayer(this.layerGroup);
    }

    const allLayers: L.Layer[] = [];

    const userStyle: L.PathOptions = { color: 'green', weight: 2, fillOpacity: 0.2 };
    const occurrenceStyle: L.PathOptions = { color: 'red', weight: 2, fillOpacity: 0.35 };

    const greenIcon = L.icon({
      iconUrl: '/assets/images/marker-icon-2x-green.png',
      shadowUrl: '/assets/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      tooltipAnchor: [16, -28],
      shadowSize: [41, 41]
    });

    const redIcon = L.icon({
      iconUrl: '/assets/marker-icon.png',
      shadowUrl: '/assets/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      tooltipAnchor: [16, -28],
      shadowSize: [41, 41],
      className: 'marker-red'
    });

    const toLatLng = ([lon, lat]: [number, number]) => [lat, lon] as [number, number];

    if (this.coordinates && this.geoType) {
      const c: any = this.coordinates;

      switch (this.geoType) {
        case 'Point': {
          const pair: [number, number] = Array.isArray(c[0]) ? (c[0] as [number, number]) : (c as [number, number]);
          const [lon, lat] = pair;
          allLayers.push(L.marker([lat, lon], { icon: greenIcon }));
          break;
        }
        case 'LineString': {
          const line: [number, number][] = (this.coordinates).map(toLatLng);
          allLayers.push(L.polyline(line, userStyle));
          break;
        }
        case 'Polygon': {
          const coords = this.coordinates;
          const isRingWrapped = Array.isArray(coords?.[0]?.[0]);
          const rings: [number, number][][] = (isRingWrapped ? coords : [coords])
            .map((ring: [number, number][]) => ring.map(toLatLng));

          allLayers.push(L.polygon(rings, userStyle));
          break;
        }
        case 'MultiPolygon': {
          const polys = (this.coordinates as any[]).map(poly =>
            poly.map((ring: any) => ring.map(([lon, lat]: number[]) => [lat, lon]))
          );
          allLayers.push(L.polygon(polys, userStyle));
          break;
        }
      }
    }

    if (this.geoData && this.geoData.length > 0) {
      this.geoData.forEach(item => {
        if (item.geometry) {
          const layer = L.geoJSON(item.geometry, {
            style: occurrenceStyle,
            pointToLayer: (feature, latlng) => {
              return L.marker(latlng, { icon: redIcon });
            }
          });
          allLayers.push(layer);
        }
      });
    }

    if (this.extraPoints && this.extraPoints.type === 'Point') {
      try {
        const [lon, lat] = this.extraPoints.coordinates;
        const pointLayer = L.marker([lat, lon], { icon: greenIcon });
        allLayers.push(pointLayer);
      } catch (e) {
        console.error('Erro ao adicionar extraPoints:', e);
      }
    }

    if (allLayers.length > 0) {
      this.layerGroup = L.featureGroup(allLayers).addTo(this.map);
      this.map.fitBounds(this.layerGroup.getBounds(), { padding: [30, 30] });
    }
  }
}